import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { getRefreshUrl } from '../helpers/getRefreshUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const UniversalAssociationsSelectSearchPaneError = () => {
  return /*#__PURE__*/_jsx("div", {
    className: "p-all-2 width-100",
    children: /*#__PURE__*/_jsx(UIAlert, {
      type: "danger",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "universalAssociationsSelect.searchPaneError_jsx",
        options: {
          href: getRefreshUrl()
        },
        elements: {
          Link: UILink
        }
      })
    })
  });
};
export default UniversalAssociationsSelectSearchPaneError;